export const List = () => import("./List.vue");
export const Create = () => import("./Create.vue");
export const BulkCreate = () => import("./BulkCreate.vue");
export const Edit = () => import("./Edit.vue");
export const Show = () => import("./Show.vue");
export const Card = () => import("./Card.vue");
export const Issue = () => import("./Issue.vue");
export const Remove = () => import("./Remove.vue");
export const MyItem = () => import("./MyItem.vue");
export const Barcode = () => import("./Barcode.vue");
export const BulkBarcode = () => import("./BulkBarcode.vue");
export const ItemUsers = () => import("./ItemUsers.vue");
export const Requisition = () => import("./Requisition.vue");
export const StoreTransfer = () => import("./StoreTransfer.vue");
export const Print = () => import("./Print.vue");
